<template>
  <div class="type">
    <span
      v-for="(item, index) in typeList"
      :key="index"
      :class="current_type === index ? 'typeActive' : 'type_item'"
      @click="checkoutType(index)"
    >{{ item.title }}</span>
  </div>
</template>

<script>
export default {
  name: "typebutton",
  props: {
    typeList: [],
    current_type: 0
  },
  data() {
    return {
      msg: "Welcome to Your Vue.js App"
    };
  },
  methods: {
    checkoutType(index) {
      this.$emit("checkType", index);
    }
  }
};
</script>
<style scoped lang="scss">
.type {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}

.type_item {
  background: #e2e2e2;
  color: #202020;
  cursor: pointer;
  width: 230px;
  height: 60px;
  font-size: 18px;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 10px;
}

.typeActive {
  background: #2525cc;
  color: #fff;
  cursor: pointer;
  width: 230px;
  height: 60px;
  font-size: 18px;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 5px;
}

.type_item:hover {
  background: #c5c5c5;
  border-color: #c5c5c5;
  color: #202020;
}
</style>



// WEBPACK FOOTER //
// src/components/typebutton.vue